import { LanguageCode } from '../languages';
import { ComposerNotesPageProps, NoteType } from './notes';
import { IntlShape } from 'react-intl';
import { SubProduct } from './user';
import { Tag } from './learn';

export type PlaylistStateType = 0 | 1;
export type PlaylistActionType =
  | 'remove'
  | 'add'
  | 'add-many'
  | 'remove-many'
  | 'reset'
  | 'rename';

export enum PlaylistType {
  WATCH_LATER = 0,
  USER_OWNED = 1,
  FOLLOWING = 2,
  RECENTLY_WATCHED = 3,
}

export enum PlayListSort {
  RECENTLY_EDITED = 'recently-edited',
  RECENTLY_CREATED = 'recently-created',
  ALPHABETICAL_A_Z = 'alphabetical-a-z',
}

export type SavedPlaylists = {
  follow: PlaylistProps[];
};

export type Playlist = {
  name: string;
  url: string;
};

export type PlaylistGroupProps = {
  type: PlaylistType;
  playlists: PlaylistProps[];
};

export type QuizAllTagSet = {
  tagID: number;
  tag: string;
  name: string;
  overrideName?: string;
  type: string;
  url: string;
  localizationKey?: string;
  accessKey?: string;
  mergeWith?: string[];
};

export type ServerPlaylistProps = {
  playlist: PlaylistProps;
};

export type PlaylistProps = {
  followers: number[];
  list: PlaylistItemProps[];
  quizAllData: QuizAllTagSet[];
  created: string;
  modified: string;
  playlistID: number;
  progress: number;
  title: string;
  type: PlaylistType;
  url: string;
  userID: number | null;
  user: {
    preferredName: string;
    lastName: string;
    avatar?: string;
  };
  userOwned: boolean;
  media: {
    ques: {
      [index: string]: {
        list: number[];
      };
    };
    fc: number[];
  };
  subType?: number;
};

export type PlaylistNavProps = {
  url: string;
  followerCount: number;
  userID: number;
  type: PlaylistType;
  data: {
    list: string;
    title: string;
  };
  saveType: PlaylistStateType;
  playlistID: number;
};

export type PlaylistsRes = {
  playlists: PlaylistProps[];
  savedPlaylists: {
    follow: PlaylistProps[];
  };
  success: PlaylistStateType;
};

export type PlaylistCreateRes = {
  url?: string;
  playlistID?: number;
  title?: string;
  userID?: number;
  list?: UserPlaylistListData[];
  success: PlaylistStateType;
  alreadyExists?: boolean;
};

/** SAME AS MOBILE */
export type QuizData = {
  fc: number[];
  ques: {
    [index: string]: {
      list: number[];
    };
  };
};

export type PlaylistVideoData = {
  progress: number | undefined;
  breadcrumb: string[] | null;
  description: string;
  displayTitle: string;
  isPrime: boolean;
  length?: string;
  mediaID: number;
  nodeID: number;
  poster: string;
  thumbnail: string;
  localizedTitles?: Record<LanguageCode, string>;
  title?: string;
  quizData?: QuizData;
  notes?: boolean; // Notes identifier
  notesType?: NoteType;
  composerNotes?: ComposerNotesPageProps;
  subType?: number;
  tags?: Tag[];
  archivedStatus: number;
  // lastTime: number[]; // Not sure if this is added
  // progress: number; // Not sure if this is added
  // views?: number; // Not sure if this is added
};

export type PlaylistItemProps = {
  accessState?: {
    [key: string]: string;
  };
  data: PlaylistVideoData;
  title: string;
  opts: {
    skipWatchedData: boolean;
  };
};

/** END MOBILE */

export type UserPlaylistListData = {
  title: string;
  video: PlaylistVideoData;
  externalSource: boolean;
  term: void[]; // not correct data
  checked?: boolean;
  displayTitle: string;
};

export type UserPlaylistMediaData = {
  userID: number;
  userOwned: boolean;
  author: { preferredName: string; lastName: string; avatar: string };
  saveType: number;
  title: string;
  list: UserPlaylistListData[];
  url: string;
  special: PlaylistStateType;
  followers: number[];
  followerCount: number;
  success: number;
};

export type UserPlaylistData = {
  thumbnail: string;
  duration: string | null;
  title: string;
  nodeID: number;
  url: string;
  isVideo: boolean;
  type: PlaylistType;
};

export type PlaylistLearnNodeItem = {
  learnNodeID: number;
  name: string;
  subProducts?: SubProduct[];
  addQuizData?: boolean;
};

export type GetFormattedPlaylistMessageProps = {
  intl: IntlShape;
  items: PlaylistLearnNodeItem[];
  playlistName: string;
};

export type VideoThumbnailsType = {
  title: string;
  resources: any[];
  learnNodeID: number;
  notes: string;
  pageType: string;
  duration: string | null;
  durationSeconds: number | null;
  url: string;
  thumbnail: string;
  watchedPercent: number | string;
  completed: number;
  addToPlaylist: {
    video: number;
    videoName: string;
    trackingSource: string;
    trackingVideoType: string;
  };
  breadcrumbs: any[];
  accessState: any;
  trackingSource: string;
  tags: string[];
};
